/**
 * Whether a bot's webview URL may be framed in Validate, and with what
 * permissions (PSTUDIO-4683).
 *
 * The frame is sandboxed the way the widget's is (`allow-scripts
 * allow-same-origin`), which is only safe for a page on ANOTHER origin: a
 * `javascript:` or `data:` URL, or a page on Pro Studio's own origin, would run
 * as Pro Studio and could read the tester's session and call the backend as
 * them. So only an https page whose origin differs from `ownOrigin` is framed,
 * and its camera/microphone/payment permissions name that origin alone.
 * `null` means show no frame.
 */
export const webviewFrame = (
  url: string,
  ownOrigin: string
): { src: string; allow: string } | null => {
  let parsed: URL;
  try {
    // Resolved against our own origin, so a relative or protocol-relative URL
    // lands on Pro Studio and is refused below rather than slipping through.
    parsed = new URL(url.trim(), ownOrigin);
  } catch {
    return null;
  }
  if (parsed.protocol !== 'https:') return null;
  if (parsed.origin === new URL(ownOrigin).origin) return null;
  const { origin } = parsed;
  return {
    src: parsed.href,
    allow: `camera ${origin}; microphone ${origin}; payment ${origin}`,
  };
};
